const uzLatn = {
    common: {
        save: 'Saqlash',
        cancel: 'Bekor qilish',
        add: 'Qo‘shish',
        new: 'Yangi',
        edit: 'Tahrirlash',
        delete: 'O‘chirish',
        search: 'Qidirish...',
        actions: 'Harakat',
        loading: 'Yuklanmoqda...',
        confirm: 'Tasdiqlash',
        close: 'Yopish',
        back: 'Orqaga',
        all: 'Hammasi',
        none: 'Yo‘q',
        today: 'Bugun',
        date: 'Sana',
        phone: 'Telefon',
        name: 'F.I.Sh.',
        status: 'Holat',
        address: 'Manzil',
        doctor: 'Shifokor',
        patient: 'Bemor',
        amount: 'Summa',
        details: 'Batafsil',
        print: 'Chop etish',
        accept: 'Qabul qilish',
        reject: 'Rad etish',
        filter: 'Filtr',
        year: 'Yil',
        province: 'Viloyat',
        district: 'Tuman',
        clear: 'Tozalash',
        yes: 'Ha',
        no: 'Yo‘q',
        id: 'ID',
        code: 'Kod',
        card: 'Karta',
        profile: 'Profil',
        logout: 'Tizimdan chiqish',
        settings: 'Sozlamalar',
        language: 'Til',
        login: 'Login',
        password: 'Parol',
        rememberMe: 'Meni eslab qolish',
        signIn: 'Kirish',
        saved: 'Saqlandi',
        total: 'Jami',
        count: 'Soni',
        remark: 'Izoh',
        type: 'Tur',
        price: 'Narx',
        empty: 'Ma’lumot yo‘q',
        more: 'Yana',
        select: 'Tanlash',
        required: 'Majburiy maydon',
        success: 'Muvaffaqiyatli',
        error: 'Xatolik',
        openMenu: 'Menyuni ochish',
        collapseSidebar: 'Panelni yig‘ish',
        expandSidebar: 'Panelni kengaytirish',
        dentalClinic: 'Stomatologiya boshqaruvi',
        perPage: '{{from}}–{{to}} / {{total}}',
        dash: '—',
        service: 'Xizmat',
        searchName: 'F.I.Sh. kiriting',
        createdAt: 'Yaratilgan sana',
        currency: 'so‘m',
        uzs: 'UZS',
        show: 'Ko‘rsatish',
        exportExcel: 'Excelga eksport',
        searchBy: '{{field}} bo‘yicha qidirish',
        reset: 'Tozalash',
        noExport: 'Eksport uchun ma’lumot yo‘q',
        loadError: 'Ma’lumot yuklanmadi',
        pageOf: 'Sahifa {{current}}/{{total}}',
        prev: 'Oldingi',
        next: 'Keyingisi',
        category: 'Kategoriya',
        qty: 'Miqdor',
        view: 'Ko‘rish',
        sender: 'Yuboruvchi',
        receiver: 'Qabul qiluvchi',
        noComment: 'Izoh yo‘q',
        unknown: 'Noma’lum',
        update: 'Yangilash',
        submit: 'Yuborish',
        create: 'Yaratish',
        identifier: 'Identifikator',
        visitDay: 'Qabul kuni',
        pieces: '{{count}} ta',
        clinicName: 'Tibbiyot klinikasi',
        email: 'Email',
        active: 'Faol',
        workPlace: 'Ish joyi',
        notEntered: 'Kiritilmagan',
    },
    nav: {
        main: 'Asosiy',
        home: 'Bosh sahifa',
        patients: 'Bemorlar',
        callCenter: 'Call markaz',
        sms: 'SMS xabarnoma',
        catalog: 'Katalog',
        doctors: 'Shifokorlar',
        discounts: 'Chegirmalar',
        smsTemplates: 'SMS shablonlar',
        services: 'Xizmatlar',
        epidem: 'Epidemiologik tarix',
        mkb10: 'XKT-10',
        partners: 'Hamkorlar',
        finance: 'Moliya',
        cash: 'Kassa',
        debtors: 'Qarzdorlar ro‘yxati',
        payments: 'To‘lovlar tarixi',
        appointments: 'Qabullar',
        allAppointments: 'Barcha qabullar',
        queue: 'Navbatda',
        reappointments: 'Qayta navbatlar',
        followups: 'Qayta qabullar',
        recall: 'Qayta qo‘ng‘iroqlar',
        patientActivity: 'Mijozlar faolligi',
        additionalServices: 'Qo‘shimcha xizmatlar',
        analytics: 'Analitika',
        reports: 'Hisobotlar',
        reportsPatients: 'Bemorlar bo‘yicha',
        reportsDoctors: 'Shifokorlar bo‘yicha',
        reportsFinance: 'Mablag‘lar bo‘yicha',
        reportsPartners: 'Hamkorlar bo‘yicha',
        inventory: 'Ombor',
        storeProducts: 'Ombor mahsulotlari',
        categories: 'Kategoriyalar',
        warehouse: 'Ombor',
        requests: 'Buyurtmalar',
        resendRequests: 'Qaytarilgan buyurtmalar',
        doctorVisits: 'Shifokor qabullari',
        doctorRequest: 'Buyurtma',
        technicianLab: 'Laboratoriya',
        technicianObjects: 'Texnik obyektlari',
        technicianRequests: 'Texnikka buyurtmalar',
        settings: 'Sozlamalar',
        roles: 'Rollar',
        users: 'Foydalanuvchilar',
    },
    status: {
        queue: 'Navbatda',
        examined: 'Qabulda',
        new: 'Yangi qabul',
        pending: 'To‘lov kutilmoqda',
        payed: 'To‘langan',
        revisit: 'Navbatda',
        closed: 'Yopilgan',
        inactive: 'Faol emas',
        planned: 'Rejalashtirilgan',
        completed: 'Bajarilgan',
        canceled: 'Bekor qilingan',
        process: 'Jarayonda',
        accept: 'Qabul qilindi',
        cancel: 'Rad etildi',
        inBase: 'Bor',
        notInBase: 'Yo‘q',
        primary: 'Asosiy',
        extra: 'Qo‘shimcha',
        all: 'Hammasi',
        ambulatory: 'Ambulator',
        stationary: 'Statsionar',
    },
    login: {
        loading: 'Yuklanmoqda...',
        success: 'Tizimga muvaffaqiyatli kirdingiz',
        error: 'Login yoki parol noto‘g‘ri',
        logoAlt: 'Logotip',
        videoFallback: 'Brauzeringiz videoni qo‘llab-quvvatlamaydi',
        welcome: 'Xush kelibsiz',
        subtitle: 'Davom etish uchun tizimga kiring',
        panelText: 'Kalendar, bemorlar va qabullar — bitta joyda',
        signingIn: 'Kirilmoqda...',
    },
    settings: {
        title: 'Sozlamalar',
        subtitle: 'Interfeys tili va platforma parametrlari',
        languageTitle: 'Interfeys tili',
        languageHint: 'Tanlangan til shu qurilmada saqlanadi va butun platformaga darhol qo‘llanadi.',
        applied: 'Til o‘zgartirildi',
        ru: 'Ruscha',
        uzLatn: 'Oʻzbekcha (lotin)',
        uzCyrl: 'Oʻzbekcha (kirill)',
        current: 'Joriy til',
    },
    patients: {
        title: 'Bemorlar',
        new: 'Yangi',
        search: 'Qidirish...',
        birthDate: 'Tug‘ilgan sana',
        card: 'Karta',
        edit: 'Tahrirlash',
        created: 'Bemor yaratildi',
        updated: 'Bemor yangilandi',
        saveError: 'Saqlashda xatolik',
        colId: '№',
        colName: 'F.I.Sh.',
        colBirth: 'Tug‘ilgan sana',
        colStatus: 'Holat',
        colAddress: 'Manzil',
        colPhone: 'Telefon',
        colActions: 'Harakat',
        formCreate: 'Yangi bemor',
        formEdit: 'Tahrirlash ⟶ {{name}}',
        formName: 'Bemor F.I.Sh.',
        formNameReq: 'Bemor F.I.Sh.ini kiriting',
        formAddress: 'Yashash manzili',
        formAddressReq: 'Yashash manzilini kiriting',
        formPartner: 'Hamkor',
        formPartnerReq: 'Hamkorni tanlang',
        formPhone: 'Telefon raqami',
        formPhoneReq: 'Telefon raqamini kiriting',
        formPhoneHint: 'Kod bilan to‘g‘ri telefon raqamini kiriting',
        formProfession: 'Kasbi',
        formBirth: 'Tug‘ilgan kuni',
        formBirthReq: 'Tug‘ilgan kunini tanlang',
        formHome: 'Uy manzili',
        formHomeReq: 'Uy manzilini kiriting',
        formWork: 'Ish manzili',
        formRemark: 'Izoh',
        formGender: 'Jinsi',
        formGenderReq: 'Jinsini tanlang',
        formPhoto: 'Rasm',
        formUpload: 'Fayl yuklash',
        formUploadHint: 'Faylni shu yerga tashlang yoki yuklash uchun bosing',
        formSubmit: 'Bemorni saqlash',
        formSubmitAdd: 'Bemor qo‘shish',
    },
    doctors: {
        title: 'Shifokorlar',
        add: 'Qo‘shish',
        edit: 'Shifokorni tahrirlash',
        create: 'Yangi shifokor',
        delete: 'O‘chirish',
        colPhone: 'Telefon',
        colRole: 'Rol',
        fio: 'F.I.Sh.',
        login: 'Login',
        password: 'Parol',
        passwordRepeat: 'Parolni takrorlang',
        phone: 'Telefon raqami',
        created: 'Shifokor yaratildi',
        updated: 'Shifokor yangilandi',
        deleted: 'Shifokor o‘chirildi',
        nameRequired: 'F.I.Sh. maydonini to‘ldiring',
        loginRequired: 'Login maydonini to‘ldiring',
        passwordRequired: 'Parol maydonini to‘ldiring',
        passwordMismatch: 'Parollar bir xil bo‘lishi kerak',
        confirmPasswordRequired: 'Parolni takrorlang',
        phoneRequired: 'Telefon raqamini to‘ldiring',
        phoneTaken: 'Bu telefon raqami allaqachon ro‘yxatdan o‘tgan',
    },
    services: {
        title: 'Asosiy xizmatlar',
        add: 'Qo‘shish',
        edit: 'Xizmatni tahrirlash',
        create: 'Xizmat qo‘shish',
        name: 'Xizmat nomi',
        price: 'Narxi',
        kind: 'Turi',
        serviceType: 'Xizmat turi',
        search: 'Xizmatni qidirish',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
    },
    partners: {
        title: 'Barcha hamkorlar',
        add: 'Qo‘shish',
        create: 'Hamkor qo‘shish',
        edit: 'Hamkorni tahrirlash',
        delete: 'Hamkorni o‘chirish',
        phone: 'Telefon raqami',
        created: 'Hamkor qo‘shildi',
        updated: 'Hamkor yangilandi',
        deleted: 'Hamkor o‘chirildi',
        saveError: 'Hamkorni saqlab bo‘lmadi',
        deleteError: 'Hamkorni o‘chirib bo‘lmadi',
    },
    discounts: {
        title: 'Mavjud chegirmalar',
        create: 'Yangi chegirma qo‘shish',
        name: 'Chegirma nomi',
        percent: 'Chegirma (%)',
        startDate: 'Boshlanish sanasi',
        endDate: 'Tugash sanasi',
        submit: 'Yaratish',
        namePlaceholder: 'Aksiya nomini kiriting',
        created: 'Yangi aksiya muvaffaqiyatli yaratildi',
        createError: 'Aksiya yaratishda xatolik yuz berdi',
    },
    sms: {
        title: 'SMS yuborish',
        templates: 'Xabar shablonlari',
        addTemplate: 'Shablon qo‘shish',
        editTemplate: 'Shablonni tahrirlash',
        send: 'SMS yuborish',
        searchPatient: 'Bemorni qidirish...',
        birthdayToday: 'Bugun tug‘ilganlarni ko‘rsatish',
        showAll: 'Barchasini ko‘rsatish',
        selectWarning: 'Bemorlar va shablonni tanlang',
        sent: 'SMS yuborildi',
        sendError: 'SMS yuborilmadi',
        loadPatientsError: 'Bemorlar yuklanmadi',
        loadTemplatesError: 'Shablonlar yuklanmadi',
    },
    smsTemplates: {
        title: 'Xabar shablonlari',
        legalEntity: 'Yuridik shaxs',
        inn: 'STIR',
        senderName: 'Yuboruvchi nomi',
        templateType: 'Shablon turi',
        text: 'Matn',
        service: 'Servis',
        transaction: 'Tranzaksiya',
        loadError: 'Shablonlar yuklanmadi',
        created: 'Shablon yaratildi',
        updated: 'Shablon yangilandi',
        deleted: 'Shablon o‘chirildi',
        saveError: 'Shablon saqlanmadi',
        deleteError: 'Shablon o‘chirilmadi',
    },
    epidem: {
        title: 'Epidemiologik tarix',
        edit: 'Yozuvni tahrirlash',
        create: 'Yozuv qo‘shish',
        name: 'Nomi',
    },
    mkb10: {
        title: 'XKT-10',
        additionalInfo: 'Qo‘shimcha ma’lumot',
    },
    payments: {
        title: 'To‘lovlar tarixi',
        date: 'To‘lov sanasi',
        serviceNumber: 'Xizmat raqami',
        total: 'Umumiy miqdor',
        paid: 'To‘langan',
        left: 'Qolgan',
        search: 'Qidirish...',
        searchBtn: 'Izlash',
        serviceName: 'Xizmat nomi',
        serviceCount: 'Xizmat soni',
        txAmount: 'Tranzaksiya miqdori',
        txType: 'Tranzaksiya turi',
        txDate: 'Tranzaksiya sanasi',
        cash: 'Naqd pul',
        card: 'Karta',
        bank: 'Bank o‘tkazmasi',
        online: 'Onlayn to‘lov',
        credit: 'Qarzga',
        creditCard: 'Kredit karta',
        enterAmount: 'To‘lov summasini kiriting',
        pay: 'To‘lash',
        paymentMethod: 'To‘lov usuli',
        paymentStatus: 'To‘lov holati',
        remaining: 'Qolgan summa',
        selectedOrder: 'Tanlangan buyurtma',
        noOrders: 'To‘lov uchun buyurtma yo‘q',
        payError: 'To‘lovni amalga oshirishda xatolik',
        paySuccess: 'To‘lov bajarildi: {{id}}',
        paidLabel: 'To‘landi: {{id}}',
        receiptNo: 'Chek №',
        thankYou: 'Xaridingiz uchun rahmat!',
        stayHealthy: 'Sog‘ bo‘ling! Klinikamizga tashrif buyurganingiz uchun tashakkur.',
        noDiscount: 'Chegirma yo‘q',
        discount: 'Chegirma (%)',
        debit: 'Debet',
        totalPaid: 'Jami to‘langan',
        finish: 'Tugatish',
        invoice: 'Hisob-faktura',
        enterPayment: 'To‘lov kiritish',
        receipt: 'Chek',
        visitNumber: 'Tashrif raqami: {{id}}',
        payTitle: 'To‘lash — {{id}}',
        paymentSlip: 'To‘lov kvitansiyasi',
        mainService: 'Asosiy xizmat',
        noServiceData: 'Xizmatlar haqida ma’lumot yo‘q',
        noOrderData: 'Buyurtma haqida ma’lumot yo‘q',
        paymentAmount: 'To‘lov summasi',
    },
    debtors: {
        title: 'Qarzdorlar ro‘yxati',
        pay: 'To‘lash',
        orderId: 'Buyurtma ID',
        transaction: 'Tranzaksiya',
        debt: 'Qarz',
    },
    admissions: {
        queue: 'Navbatlar',
        reappointments: 'Qayta navbatlar',
        followups: 'Qayta qabullar',
        recall: 'Qayta qo‘ng‘iroqlar',
        dispensary: 'Dispanser hisobi',
        paymentReceipt: 'To‘lov → chek',
        paymentInfo: 'To‘lov ma’lumoti',
        printReceipt: 'Chek chiqarish',
        callResult: 'Qo‘ng‘iroq natijasi',
        addToQueue: 'Qabulga qo‘shish',
        revisitDate: 'Qayta qabul sanasi',
        visitCreated: '{{name}} bemori uchun tashrif yaratildi',
        visitCreateError: 'Tashrif yaratishda xatolik',
        visitId: 'Tashrif ID',
        noServices: 'Xizmat yo‘q',
        payment: 'To‘lov',
        remaining: 'Qolgan summa',
    },
    reports: {
        patients: 'Bemorlar bo‘yicha hisobot',
        doctors: 'Shifokorlar bo‘yicha hisobot',
        finance: 'Mablag‘lar bo‘yicha hisobot',
        financeDate: 'Shifokorning mablag‘ hisoboti {{date}}',
        partners: 'Hamkorlar bo‘yicha tahlil',
        partnersShare: 'Hamkorlar ulushi',
        doctorDetail: 'Shifokorning batafsil hisoboti',
        info: 'Ma’lumot',
        show: 'Ko‘rsatish',
        exportExcel: 'Excelga eksport',
        doctorName: 'Shifokor F.I.Sh.',
        patientsSeen: 'Ko‘rilgan bemorlar',
        patientsCount: 'Kelgan bemorlar soni',
        totalAmount: 'Jami summa',
        partner: 'Hamkor',
        todayCame: 'Bugun keldi',
        newPatients: 'Yangi bemorlar',
        repeatPatients: 'Qayta bemorlar',
        share: 'Ulush (%)',
        allPartners: 'Barcha hamkorlar',
        patientName: 'Bemor ismi',
        noExport: 'Eksport uchun ma’lumot yo‘q',
        loadError: 'Ma’lumot yuklanmadi',
        badFormat: 'API ma’lumot formati noto‘g‘ri',
        search: 'Qidirish',
        reset: 'Tozalash',
        searchBy: '{{field}} bo‘yicha qidirish',
    },
    store: {
        categories: 'Barcha kategoriyalar',
        addCategory: 'Kategoriya qo‘shish',
        editCategory: 'Kategoriyani tahrirlash',
        warehouse: 'Ombor mahsuloti',
        history: 'Tarix',
        add: 'Qo‘shish',
        edit: 'Tahrirlash',
        requests: 'Buyurtmalar',
        resend: 'Qaytarilgan buyurtmalar',
        accept: 'Qabul qilish',
        reject: 'Rad etish',
        details: 'Batafsil',
        fullRemark: 'To‘liq izoh',
        doctorRequests: 'Buyurtmalar',
        returnGoods: 'Tovarni qaytarish',
        newRequest: 'Yangi buyurtma',
        name: 'Nomi',
        addNew: 'Yangi qo‘shish',
        namePh: 'nomi',
        update: 'Yangilash',
        deleted: 'Kategoriya o‘chirildi',
        deleteError: 'O‘chirishda xatolik',
        added: 'Kategoriya qo‘shildi',
        updated: 'Kategoriya yangilandi',
        saveError: 'Saqlashda xatolik',
        grandTotal: 'Umumiy',
        requestHistory: 'So‘rovnoma tarixi',
        sender: 'Yuboruvchi',
        receiver: 'Qabul qiluvchi',
        notReceived: 'Qabul qilinmagan',
        noRemark: 'Izoh yo‘q',
        historyQty: 'Tarixi (Miqdor: {{qty}})',
        nameFilter: 'nomini kiriting...',
        pickCategory: 'Kategoriyani tanlang',
        excelExport: 'Excel eksport',
        exportOk: 'Eksport muvaffaqiyatli',
        exportError: 'Eksportda xatolik yuz berdi',
        fillFields: 'Barcha maydonlarni to‘ldiring',
        loadError: 'Ma’lumot yuklanmadi',
        productUpdated: 'Mahsulot muvaffaqiyatli o‘zgardi',
        view: 'Ko‘rish',
        pricePh: 'narxi',
        qtyPh: 'miqdor',
        categoryPh: 'kategoriya',
        confirmer: 'Tasdiqlovchi',
        notConfirmed: 'Tasdiqlanmagan',
        remarks: 'Izohlar',
        commentMin: 'Izoh kamida 10 belgidan iborat bo‘lishi kerak!',
        commentForAccept: 'Qabul qilish uchun izoh',
        commentForReject: 'Rad etish uchun izoh',
        commentPh: 'Izoh kiriting...',
        phoneNumber: 'Raqami',
        returnedOk: 'Mahsulot muvaffaqiyatli omborga qaytarildi!',
        confirmAccept: 'Haqiqatan ham qabul qilishni xohlaysizmi?',
        confirmReject: 'Haqiqatan ham rad etishni xohlaysizmi?',
        addedOk: 'Buyurtma qo‘shildi',
        addError: 'Qo‘shishda xatolik',
        updateError: 'Yangilashda xatolik',
        deletedOk: 'O‘chirildi',
        fetchError: 'Buyurtmalar yuklanmadi',
        qtyMax: 'Miqdor 100 dan oshmasligi kerak!',
        returnOk: 'Tovar muvaffaqiyatli qaytarildi',
        returnError: 'Tovarni qaytarishda xatolik',
        fetchWarehousesError: 'Ombor yuklanmadi',
        createOk: 'Buyurtma muvaffaqiyatli yuborildi!',
        createError: 'Buyurtma yaratishda xatolik',
        send: 'Yuborish',
        qtyLabel: 'Miqdor (maks: {{qty}})',
        qtyRequired: 'Miqdorni kiriting',
        qtyExceed: 'Mavjud: {{qty}} ta',
        qtyPhInput: 'Miqdorni kiriting',
        commentOptional: 'Izoh kiriting (ixtiyoriy)',
        pickProduct: 'Mahsulot tanlang',
        pickProductRequired: 'Iltimos, mahsulot tanlang!',
        qtyZero: 'Miqdor 0 bo‘lishi mumkin emas!',
        qtyMaxAvailable: 'Eng ko‘p mavjud: {{qty}} ta',
        warehouseLabel: 'Ombor',
        fetchDataError: 'Ma’lumot yuklashda xatolik',
        fetchCategoriesError: 'Kategoriyalar yuklanmadi',
        requestDeleted: 'Buyurtma o‘chirildi',
        requestDeleteError: 'Buyurtmani o‘chirishda xatolik',
        comment: 'Izoh',
    },
    callCenter: {
        title: 'Qo‘ng‘iroqlar markazi',
        new: 'Yangi',
        planned: 'Rejalashtirilgan',
        completed: 'Bajarilgan',
        canceled: 'Bekor qilingan',
        allTime: 'Barcha vaqt',
        searchName: 'F.I.Sh.',
        searchPhone: 'Telefon',
        date: 'Sana',
        schedule: 'Rejalashtirish',
        scheduleCall: 'Qo‘ng‘iroqni rejalashtirish',
        newUser: 'Yangi foydalanuvchi',
        all: 'Barchasi',
        source: 'Qayerdan eshitdi?',
        base: 'Baza',
        callTime: 'Qo‘ng‘iroq vaqti',
        inBase: 'Bazada',
        add: 'Qo‘shish',
        pickDateTime: 'Sana va vaqtni tanlang',
        fillNamePhone: 'Ism va telefonni to‘ldiring',
        added: 'Foydalanuvchi qo‘shildi',
        addError: 'Qo‘shishda xatolik',
        loadError: 'Ma’lumot yuklanmadi',
        statsError: 'Statistika yuklanmadi',
        partnersError: 'Hamkorlar yuklanmadi',
        patientsError: 'Bemorlar yuklanmadi',
        statusUpdated: 'Holat yangilandi',
        statusError: 'Holatni yangilashda xatolik',
        notFound: 'Yozuv topilmadi',
        time: 'Vaqt',
        sourcePlaceholder: 'Manbani tanlang',
        userName: 'Foydalanuvchi ismi',
        baseStatus: 'Baza holati',
        birthAt: 'Tug‘ilgan sana',
        age: 'Yoshi',
        minor: 'Voyaga yetmagan',
        adult: 'Voyaga yetgan',
        guardians: 'Qarindoshlar',
        guardian: 'Vasiy',
        relative: 'Qarindosh',
        addGuardian: 'Qo‘shish',
        noGuardians: 'Biriktirilgan shaxslar yo‘q',
        guardianName: 'F.I.Sh.',
        guardianPhone: 'Telefon, masalan 998901112233',
        relationship: 'Qarindoshlik',
        address: 'Manzil',
        notes: 'Izoh',
        guardianNameRequired: 'Ismni yozing',
        guardianPhoneRequired: 'Telefonni yozing',
        relationshipRequired: 'Qarindoshlikni yozing',
        guardianAdded: 'Shaxs qo‘shildi',
        guardianUpdated: 'Ma’lumot yangilandi',
        guardianDeleted: 'Yozuv o‘chirildi',
        guardianSaveError: 'Saqlab bo‘lmadi',
        guardianDeleteConfirm: 'Bu shaxsni liddan o‘chirish?',
        forbidden: 'Ruxsat yo‘q',
    },
    doctorVisits: {
        title: 'Shifokor qabullari',
        endVisit: 'Qabulni tugatish',
        confirm: 'Tasdiqlash',
        confirmEnd: 'Qabulni tugatishni xohlaysizmi?',
        ended: 'Qabul muvaffaqiyatli yopildi',
        yesEnd: 'Ha, tugatish',
        patientCard: 'Bemor kartasi',
        patientName: 'Bemor',
        unknownDoctor: 'Noma’lum shifokor',
        unknownPatient: 'Noma’lum bemor',
        service: 'Xizmat',
        time: 'Vaqt',
        queueNo: 'Navbat',
        allStatuses: 'Hammasi',
        loadError: 'Qabullarni yuklab bo‘lmadi',
        forbidden: 'Faqat shifokor uchun',
        endError: 'Qabulni tugatib bo‘lmadi',
    },
    calendar: {
        search: 'Qidirish...',
        pickDate: 'Sanani tanlang',
        newVisit: 'Yangi qabul',
        editVisit: 'Qabulni tahrirlash',
        viewVisit: 'Qabulni ko‘rish',
        welcome: 'Xush kelibsiz',
        today: 'Bugun',
        todayDoctors: 'Bugun · shifokorlar',
        calendar: 'Kalendar',
        doctors: 'Shifokorlar',
        day: 'Kun',
        week: 'Hafta',
        month: 'Oy',
        visits: 'qabul',
        withDoctor: 'shifokor bilan',
        withoutDoctor: 'shifokorsiz',
        noRecords: 'Yozuv yo‘q',
        unassigned: 'Shifokor belgilanmagan',
        dentist: 'Stomatolog',
        add: 'Qo‘shish',
        past: 'O‘tgan',
        planned: 'Reja',
        todayLabel: 'Bugun',
        prevMonth: 'Oldingi oy',
        nextMonth: 'Keyingi oy',
        prevWeek: 'Oldingi hafta',
        nextWeek: 'Keyingi hafta',
        prevDay: 'Oldingi kun',
        nextDay: 'Keyingi kun',
        layoutMonth: '1 · Oylik kalendar',
        layoutDay: '2 · Shifokorlar (kun)',
        layoutWeek: '2 · Shifokorlar (hafta)',
        layoutMonthBoard: '2 · Shifokorlar (oy)',
        todayVisits: 'Bugungi qabullar',
        date: 'Sana',
        fio: 'F.I.Sh.',
        phone: 'Telefon',
        patientOptional: 'Bemor (ixtiyoriy)',
        doctorOptional: 'Shifokor (ixtiyoriy)',
        description: 'Tavsif',
        save: 'Saqlash',
        update: 'O‘zgartirish',
        deleteEvent: 'Yozuvni o‘chirish',
        searchPatient: 'F.I.Sh. bo‘yicha qidirish...',
        pickDoctor: 'Shifokorni tanlang',
        descriptionPh: 'Tavsif...',
        todayReceptions: 'Bugungi qabullar',
        bugungi: 'Bugungi qabullar',
        updated: 'Yozuv yangilandi',
        updateError: 'Yozuvni yangilab bo‘lmadi',
        created: 'Yozuv yaratildi',
        createError: 'Yozuv yaratilmadi',
        pickDateError: 'Sanani tanlang',
        fioRequired: 'F.I.Sh. kiriting',
        phoneRequired: 'Telefon raqamini kiriting',
        dateRequired: 'Sanani tanlang',
        noTodayVisits: 'Bugun qabullar yo‘q',
        noDoctorsList: 'Shifokorlar ro‘yxati yo‘q',
        moreCount: '+{{count}} yana',
        layoutCalendar: '1 · Kalendar',
        layoutDoctors: '2 · Shifokorlar',
        registerPatient: 'Bemorni ro‘yxatdan o‘tkazish',
        phonePh: 'Telefon raqami:',
        dowMon: 'Du',
        dowTue: 'Se',
        dowWed: 'Ch',
        dowThu: 'Pa',
        dowFri: 'Ju',
        dowSat: 'Sh',
        dowSun: 'Ya',
    },
    dental: {
        formula: 'Tish formulasi',
        upper: 'Yuqori',
        lower: 'Pastki',
        all: 'Hammasi',
        clear: 'Tozalash',
        unselected: 'Tanlanmagan',
        selected: 'Tanlangan',
        hasRemark: 'Izoh mavjud',
        selectedCount: 'Tanlangan',
        save: 'Saqlash',
        jawUpper: 'yuqori jag‘',
        jawLower: 'pastki jag‘',
        tooth: 'Tish {{id}}',
        remarkPh: 'Izoh kiriting',
        remarksTitle: 'Tanlangan tishlar bo‘yicha izohlar',
        problems: 'Muammolar',
        xrays: 'Rentgenlar',
        noXrays: 'Rentgen suratlar yo‘q',
        jawAreas: 'Jag‘ sohalari',
        pickJaw: 'Jag‘ sohasini tanlang',
        pickProblem: 'Muammoni tanlang',
        searchProblems: 'Jag‘ va muammolar bo‘yicha qidirish',
        jawLeft: 'Chap tomon',
        jawRight: 'O‘ng tomon',
        malocclusion: 'Noto‘g‘ri tishlash',
        crossbite: 'Kesishgan tishlash',
        diastema: 'Diastema',
        crowding: 'Tish qiyshiqligi',
        malposition: 'Tishning noto‘g‘ri joylashuvi',
        teethSaved: 'Tish ma’lumotlari muvaffaqiyatli yuborildi',
    },
    patientCard: {
        title: 'Bemor kartasi',
        hideProfile: 'Profilni yashirish',
        showProfile: 'Profilni ko‘rsatish',
        visitNo: 'Qabul №',
        startVisit: 'Qabulni boshlash',
        starting: 'Boshlanmoqda...',
        endVisit: 'Qabulni tugatish',
        ending: 'Tugatilmoqda...',
        createVisit: 'Qabul yaratish',
        addEpidem: 'Epidanamnez qo‘shish',
        notAvailable: 'Mavjud emas',
        birthDate: 'Tug‘ilgan sana',
        phone: 'Telefon',
        province: 'Viloyat',
        district: 'Tuman',
        partner: 'Hamkor',
        address: 'Manzil',
        profession: 'Kasbi',
        gender: 'Jinsi',
        visits: 'Qabullar',
        noteText: 'Izoh matni',
        male: 'Erkak',
        female: 'Ayol',
        addToVisit: 'Qabulga qo‘shish',
        pickService: 'Xizmatni tanlang',
        discount: 'Chegirma',
        pickDiscount: 'Chegirmani tanlang',
        visitAdded: 'Qabul qo‘shildi',
        noDoctors: 'Mavjud shifokorlar yo‘q',
        newVisitSubmit: 'Yangi qabul qo‘shish',
        readyTitle: 'Bemor qabul boshlanishiga tayyor',
        readyDesc: 'Bemor xizmat uchun to‘ladi, qabulni boshlash mumkin',
        addedTitle: 'Yangi qabul qo‘shildi',
        addedDesc: 'Qabul qo‘shilgan, ammo bemor hali to‘lamagan',
        notAddedTitle: 'Bemor qabulga qo‘shilmagan',
        notAddedDesc: 'Davolashni boshlash uchun bemorni qabulga qo‘shing',
        tabNewVisit: 'Yangi qabul',
        tabHistory: 'Tashrif va qo‘ng‘iroqlar',
        tabViewVisits: 'Qabullarni ko‘rish',
        visitsTitle: 'Qabullar',
        visitAt: 'Tashrif: {{date}}',
        visitNoN: 'Tashrif №{{id}}',
        dateAt: 'Sana: {{date}}',
        revisitDate: 'Qayta qabul sanasi',
        onDispensary: 'Dispanser hisobiga olinganmi',
        viewAll: 'Barcha ma’lumotlarni ko‘rish',
        fileNotUploaded: 'Fayl yuklanmagan',
        noInfo: 'Ma’lumot yo‘q',
        visitDate: 'Tashrif sanasi',
        paymentType: 'To‘lov turi',
        loadingData: 'Ma’lumot yuklanmoqda...',
        complaint: 'Shikoyat',
        illness: 'Kasallik',
        diagnosis: 'Tashxis',
        illHistory: 'Kasallik tarixi',
        anamnez: 'Anamnez {{n}}',
        treatment: 'Davolash',
        oralView: 'Og‘iz bo‘shlig‘i ko‘rinishi.',
        teethState: 'Tishlarning holati:',
        totalForms: 'Jami {{total}} ta forma',
        workAddress: 'Ish joyi',
        sentBy: 'Kim yubordi',
        epidemAdded: 'Epidemiologik anamnez qo‘shildi',
        added: 'Qo‘shildi',
        noDistrict: 'Tuman ma’lumoti yo‘q',
        noPartner: 'Hamkor ma’lumoti yo‘q',
        colTitle: 'Nomlanishi',
        colDesc: 'Tavsif',
        colActive: 'Faol',
        cityDistrict: 'Shahar/tuman',
        filesTypes: 'Rentgen, hujjat, rasm ...',
        createVisitAction: 'Qabulni yaratish',
        patientFio: 'Bemor F.I.Sh.',
        condExtracted: 'Tortilgan tish',
        condRoot: 'Tomir qolgan',
        condCaries: 'Karies',
        condPulpitis: 'Pulpits',
        condPeriodontitis: 'Periodontit',
        condParadontosis: 'Paradontoz',
        condMobility: 'Qimirlatish',
        condFilling: 'Qoplama',
        condArtificial: 'Sun’iy tish',
    },
    notfound: {
        code: '404',
        title: 'Sahifa topilmadi',
        text: 'Kechirasiz, bu sahifa mavjud emas. Bosh sahifaga qaytishingiz mumkin.',
        home: 'Bosh sahifa',
    },
    roles: {
        title: 'Rollar',
        create: 'Rol qo‘shish',
        select: 'Rolni tanlang',
    },
    users: {
        title: 'Foydalanuvchilar',
        add: 'Qo‘shish',
        edit: 'Tahrirlash',
        delete: 'O‘chirish',
        create: 'Yangi foydalanuvchi',
        editTitle: 'Foydalanuvchini tahrirlash',
        role: 'Rol',
        phonePlaceholder: 'Telefon raqami',
        created: 'Foydalanuvchi yaratildi',
        updated: 'Foydalanuvchi yangilandi',
        deleted: 'Foydalanuvchi o‘chirildi',
        passwordMismatch: 'Parollar mos emas',
        addTechnician: 'Texnik qo‘shish',
        technicianCreated: 'Texnik yaratildi',
    },
    form43: {
        part1: 'I qism',
        part2: 'II qism',
        part3: 'III qism',
        part4: 'IV qism',
        headerLeft: 'O‘ZBEKISTON RESPUBLIKASI SOG‘LIQNI SAQLASH VAZIRLIGI',
        headerRight: 'Sog‘liqni saqlash vazirligining 043/u shaklidagi tibbiy hujjati',
        title: 'STOMATOLOGIYA BEMORINING TIBBIY VARAQASI',
        fullName: 'Ismi sharifi',
        birthYear: 'Tug‘ilgan yili',
        address: 'Turar joyi',
        job: 'Ish joyi, kasbi',
        diagnosis: 'Tashxis',
        complaints: 'Shikoyati',
        childhoodHistory: 'Bolalikda va keyingi paytda qanday kasal bo‘lgan',
        childhoodHistoryPh: 'Kasallik tarixi',
        currentHistory: 'Hozirgi kasallikning boshlanish tarixi',
        currentHistoryPh: 'Hozirgi kasallik tarixi',
        epidemQ1: 'Epid anamnez: 1) Infeksion bemorlar bilan kontaktda bo‘lganmi?',
        epidemQ2: '2) 1 hafta – 2 oy mobaynida turar joyidan chetga chiqqanmi?',
        epidemQ2Ph: 'Turar joyidan chetga chiqqanmi?',
        epidemQ3: '3) Qaysi infeksion kasalliklarni boshidan kechirgan?',
        epidemQ4: '4) Statsionar va ambulator davolanganmi?',
        epidemQ5: '5) Parenteral muolajalar olganmi?',
        epidemQ6: '6) Maishiy xizmatlardan foydalanganmi?',
        allergy: 'Allergoanamnez: turli dori va ovqat mahsulotlariga allergiya bormi?',
        allergyPh: 'Allergiya bor, yo‘q?',
        clinicalDiagnosis: 'Anamnez va klinik ko‘rsatmalarga ko‘ra aniqlashga mo‘ljallangan tashxis (diagnoz)',
        appearance: 'Tashqi ko‘rinish',
        teethCondition: 'Tishlarning holati',
        condExtracted: 'Tortilgan tish – O',
        condRoot: 'Tomir qolgan – R',
        condCaries: 'Karies – C',
        condPulpitis: 'Pulpits – P',
        condPeriodontitis: 'Periodontit – A',
        condMobility: 'Qimirlatish – I-III',
        condFilling: 'Qoplama – K',
        condArtificial: 'Sun’iy tish – I',
        treatment: 'Davolash',
    },
    queues: {
        title: 'Yangi navbat',
        select: 'Bemor va shifokorni tanlang',
        visitTime: 'Qabul vaqti',
        busy: 'band',
        noDate: 'Sana yo‘q',
        notStarted: 'Qabul boshlanmagan',
        doctorsError: 'Shifokorlar yuklanmadi',
        created: 'Bemor {{patientId}} va shifokor {{doctorId}} uchun qabul yaratildi',
        confirmVisit: 'Qabulni tasdiqlash',
    },
    followupsPage: {
        title: 'Qayta qo‘ng‘iroqlar',
        dueHint: 'Muddati kelgan bemorlar: {{count}}',
        dueDate: 'Qo‘ng‘iroq muddati',
        enterResult: 'Natija kiritish',
        loadError: 'Ro‘yxat yuklanmadi',
        saved: 'Natija saqlandi',
        alreadyClosed: 'Eslatma allaqachon yopilgan',
        saveError: 'Saqlashda xatolik',
        total: 'Jami: {{total}}',
        remarkOptional: 'Izoh (ixtiyoriy)',
        remarkPh: 'Izoh...',
        noAnswer: 'Javob bermadi',
        contacted: 'Bog‘lanildi',
        willVisit: 'Kelishini aytdi',
    },
    unauthorized: {
        title: 'Ruxsat yo‘q',
        text: 'Bu sahifani ko‘rish uchun huquqingiz yo‘q.',
        home: 'Bosh sahifa',
    },
    admissionPrint: {
        title: 'Bemor ma’lumoti',
        print: 'Printerdan chiqarish',
        diseases: 'Kasalliklarning xalqaro tasnifi',
        conclusion: 'Shifokor xulosasi',
        noConclusion: 'Xulosa yo‘q...',
        revisits: 'Qayta qabullar',
        noRevisits: 'Qayta tashriflar yo‘q',
        dispensary: 'Dispanser ro‘yxatlari',
        dispensaryDate: 'Dispanser sanasi',
        noDispensary: 'Dispanser yozuvlari yo‘q',
        files: 'Yuklangan fayllar',
        notFound: 'Bemor ma’lumoti topilmadi',
        photo: 'Surat',
        code: 'Kod',
        mkb10: 'XKT-10',
        conclusionLabel: 'Xulosa',
        loading: 'Yuklanmoqda',
        filesTypes: 'Rentgen, hujjat, rasm ...',
        loadError: 'Bemor ma’lumoti olinmadi',
    },
    visit: {
        conclusion: 'Shifokor xulosasi',
        dragFiles: 'Fayl(lar)ni bu yerga tashlang yoki',
        clickFiles: 'fayl(lar)ni tanlash uchun bosing',
        saveSend: 'Saqlash va yuborish',
        loadingTemplates: 'Shablonlar yuklanmoqda...',
        pickTemplate: 'Shablonni tanlang',
        addTemplate: 'Shablon qo‘shish',
        templateName: 'Shablon nomini kiriting',
        sendTemplate: 'Shablonni yuborish',
        send: 'Yuborish',
        revisit: 'Qayta qabul',
        addRevisit: 'Qayta qabulga qo‘shish',
        procedure: 'Protseduraga yuborish',
        addDispensary: 'Dispanser ro‘yxatiga qo‘shish',
        filesSent: 'Rasmlar yuborildi',
        filesError: 'Fayllarni yuklashda xatolik yuz berdi',
        commentSent: 'Izoh yuborildi',
        commentError: 'Izoh yuborishda xatolik',
        templateSent: 'Shablon yuborildi',
        templateError: 'Shablon yuborishda xatolik',
        mkbAdded: 'XKT qo‘shildi',
        pickDate: 'Iltimos, kunni tanlang',
        revisitSet: 'Qayta qabul: {{date}}',
        dispensarySet: 'Dispanser ro‘yxati: {{date}}',
        colName: 'Nomlanishi',
    },
    history: {
        loadFailed: 'Tarix yuklanmadi',
        summary: 'Umumiy ma’lumot',
        lastVisit: 'Oxirgi tashrif',
        nextVisit: 'Keyingi qabul',
        nextContact: 'Keyingi qayta bog‘lanish',
        timeNotSet: 'Vaqti belgilanmagan',
        visitsHistory: 'Tashriflar tarixi',
        noVisits: 'Tashriflar yo‘q',
        callsHistory: 'Qo‘ng‘iroqlar tarixi (oxirgi 10)',
        noCalls: 'Qo‘ng‘iroq tarixi yo‘q',
        registeredBy: 'Ro‘yxatga olgan',
        services: 'Xizmatlar',
        noAnswer: 'Javob bermadi',
        contacted: 'Bog‘lanildi',
        willVisit: 'Kelishini aytdi',
    },
    techRequest: {
        catalogTitle: 'Texnik obyektlari',
        catalogNew: 'Yangi obyekt',
        catalogEdit: 'Obyektni tahrirlash',
        requestsTitle: 'Texnikka buyurtmalar',
        requestsTitleDoctor: 'Texnikka buyurtmalarim',
        requestsTitleTech: 'Buyurtmalar',
        newOrder: 'Yangi buyurtma',
        object: 'Obyekt',
        parameters: 'Parametrlar',
        addParameter: 'Parametr qo‘shish',
        options: 'Variantlar',
        requiredParam: 'Majburiy',
        objectPrice: 'Obyekt narxi',
        paramPrice: 'Parametr narxi',
        estimatedTotal: 'Dastlabki summa',
        finalPrice: 'Yakuniy narx',
        parametersTotal: 'Parametrlar jami',
        description: 'Qo‘shimcha talablar',
        descriptionPh: 'Qo‘shimcha talablarni yozing',
        actionNote: 'Izoh',
        actionNotePh: 'Amal izohi (ixtiyoriy)',
        technician: 'Texnik',
        orderedBy: 'Buyurtma bergan shifokor',
        selectObject: 'Obyektni tanlang',
        selectTechnician: 'Texnikni tanlang',
        selectPatient: 'Bemorni tanlang',
        preview: 'Hisob',
        snapshotNote: 'Narxlar buyurtma yuborilgan paytdagi qiymatda saqlanadi.',
        pending: 'Yangi',
        inProgress: 'Jarayonda',
        completed: 'Bajarilgan',
        returned: 'Qaytarilgan',
        start: 'Ishni boshlash',
        complete: 'Bajarilgan deb belgilash',
        returnWork: 'Qayta ishlashga qaytarish',
        returnReason: 'Qaytarish sababi',
        lastReturn: 'Oxirgi qaytarish',
        changePrice: 'Narxni o‘zgartirish',
        newPrice: 'Yangi narx',
        priceNote: 'Narx izohi',
        history: 'Tarix',
        historyEmpty: 'Tarix yo‘q',
        statusChanged: 'Holat o‘zgarishi',
        priceChanged: 'Narx o‘zgarishi',
        inactive: 'Nofaol',
        active: 'Faol',
        deactivate: 'Tanlovdan yashirish',
        activate: 'Faollashtirish',
        deleteConfirm: 'Obyekt katalogdan olib tashlansinmi? Eski buyurtmalar saqlanadi.',
        loadError: 'Ma’lumotlarni yuklab bo‘lmadi',
        saveError: 'Saqlab bo‘lmadi',
        forbidden: 'Ruxsat yo‘q',
        conflict: 'Bu amal hozir mumkin emas',
        notFound: 'Yozuv topilmadi',
        createdOk: 'Buyurtma yuborildi',
        savedOk: 'Saqlandi',
        deletedOk: 'O‘chirildi',
        startedOk: 'Ish boshlandi',
        completedOk: 'Bajarilgan deb belgilandi',
        returnedOk: 'Buyurtma qaytarildi',
        priceUpdated: 'Narx yangilandi',
        noTechnicians: 'Texniklar yo‘q',
        noObjects: 'Faol obyektlar yo‘q',
        requiredParamsMissing: 'Majburiy parametrlarni to‘ldiring',
        descriptionRequired: 'Qo‘shimcha talablarni yozing',
        returnRequired: 'Qaytarish sababini yozing',
        optionsRequired: 'Kamida bitta variant qo‘shing',
        paramName: 'Parametr nomi',
        from: 'Oldin',
        to: 'Keyin',
        tooth: 'Tish',
        toothOptional: 'ixtiyoriy',
        adultTeeth: 'Doimiy',
        childTeeth: 'Sut tishlari',
    },
    patientActivity: {
        title: 'Mijozlar faolligi',
        search: 'Ism, telefon yoki kod',
        overdue: '6 oydan beri kelmagan',
        recent: 'So‘nggi 6 oyda kelgan',
        never_visited: 'Hali kelmagan',
        visited: 'Barcha kelganlar',
        overdueHint: 'Oxirgi tashrif chegaradan oldin',
        recentHint: 'Oxirgi tashrif chegaradan keyin',
        neverHint: 'Yopilgan qabul yo‘q',
        visitedHint: 'Kamida bitta tashrif',
        lastVisit: 'Oxirgi tashrif',
        visitsCount: 'Qabullar',
        createdAt: 'Yaratilgan',
        neverVisitedLabel: 'Hali kelmagan',
        history: 'Tarix',
        cutoffNote: 'Bugun {{today}} · 6 oylik chegara {{cutoff}}',
        loadError: 'Ro‘yxat yuklanmadi',
        forbidden: 'Ruxsat yo‘q',
    },
    additionalServices: {
        title: 'Qo‘shimcha xizmatlar',
        add: 'Qo‘shish',
        create: 'Yangi qo‘shimcha xizmat',
        edit: 'Xizmatni tahrirlash',
        search: 'Nom bo‘yicha qidirish',
        name: 'Nomi',
        price: 'Narxi',
        description: 'Izoh',
        prefix: 'Prefiks',
        time: 'Daqiqa',
        author: 'Muallif',
        createdBy: 'Yaratgan',
        performedBy: 'O‘zgartirgan',
        history: 'Tarix',
        includeDeleted: 'Arxivni ko‘rsatish',
        active: 'Faol',
        archived: 'Arxiv',
        created: 'Xizmat yaratildi',
        updated: 'Xizmat yangilandi',
        deleted: 'Xizmat o‘chirildi',
        deleteConfirm: 'Xizmatni o‘chirish? Tarix saqlanadi.',
        nameRequired: 'Nomini yozing',
        priceRequired: 'Narxni yozing',
        saveError: 'Saqlab bo‘lmadi',
        forbidden: 'Faqat admin uchun',
        notFound: 'Xizmat topilmadi',
        action: 'Amal',
        changes: 'O‘zgarishlar',
        action_created: 'Yaratildi',
        action_updated: 'O‘zgartirildi',
        action_deleted: 'O‘chirildi',
        field_name: 'Nomi',
        field_price: 'Narxi',
        field_description: 'Izoh',
        field_prefix: 'Prefiks',
        field_time: 'Daqiqa',
        field_type: 'Turi',
        field_deleted_at: 'O‘chirilgan',
    },
};

export default uzLatn;
